import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		user: null,
		test: {
			text: 'DefaultStoreTestText'
		}
	},
	mutations: {
		changeText(state, text) {
			//console.log(text);
			state.test.text = text;
		},
		setUser(state, user) {
			state.user = user;
		}
	},
	actions: {},
	getters: {
		storeTestText: state => state.test.text,
		isLoggedIn: state => state.user !== null,
		username: state => state.user
	}
});
